import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const ContentLayout = ({ children, isRelative }) => {
    return (
        <div
            id="contentLayout"
            className={clsx(
                'w-full h-full flex flex-col items-center justify-start max-h-full overflow-auto',
                isRelative && 'relative',
            )}
        >
            {children}
        </div>
    )
}

ContentLayout.propTypes = {
    children: PropTypes.node,
    isRelative: PropTypes.bool,
}

export default ContentLayout
